import { gql, useQuery } from "@apollo/client";

export const GET_PRODUCT_FILTERS_BY_CATEGORY = gql`
  query getCategoryFiltersData($filter: ProductAttributeFilterInput!) {
    products(filter: $filter) {
      aggregations {
        label
        count
        attribute_code
        options {
          label
          value
          swatch_data {
            value
          }
          count
        }
        position
      }
    }
  }
`;

export const useGetFilterData = ({
  categoryId,
  filtersCondition,
  initialData,
}: {
  categoryId: string;
  filtersCondition: any;
  initialData?: any[] | null;
}) => {
  // 服务端已经预取了 aggregations，直接用，不发客户端请求
  const skip = Array.isArray(initialData) && initialData.length > 0;

  const { data: filterData, loading: filterLoading } = useQuery(GET_PRODUCT_FILTERS_BY_CATEGORY, {
    variables: { filter: filtersCondition },
    skip,
  });

  const filters = skip ? initialData : (filterData?.products?.aggregations || null);
  const shouldShowFilterButtons = filters && filters.length;
  const shouldShowFilterShimmer = filters === null;

  return {
    filters,
    shouldShowFilterButtons,
    shouldShowFilterShimmer,
    filterLoading: skip ? false : filterLoading,
  };
};
